import styled, { DefaultTheme } from 'styled-components';

export const ToggleButtonWrapper = styled.div`
  position: relative;
  display: flex;
  height: fit-content;
  flex-direction: ${(props) => (props.theme.rtl ? 'row-reverse' : 'row')};
`;

export const ToggleButtonLabel = styled.label<{ defaulttheme: DefaultTheme; checked: boolean }>`
  width: 28px;
  height: 14px;
  border-radius: 20px;
  background: ${({ defaulttheme, checked }) =>
    checked ? defaulttheme.colors.text.primary : defaulttheme.colors.border.middle};
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 11px;
    height: 11px;
    transition: 0.2s;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    background: ${({ defaulttheme }) => defaulttheme.colors.text.inverse};
    left: ${({ checked }) => (checked ? '16px' : '1px')};
  }
`;

export const CheckBox = styled.input<{
  defaulttheme: DefaultTheme;
}>`
  position: relative;
  opacity: 0;
  z-index: 1;
  width: 38px;
  height: 24px;
  border-radius: 28px;
  margin: 0;
  cursor: pointer;
  transform: ${(props) => (props.theme.rtl ? 'scaleX(-1)' : 'unset')};
`;
